import AssignmentIcon from "@mui/icons-material/Assignment";
import { Box, Typography } from "@mui/material";
import type { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import type { FC, MouseEvent } from "react";
import { useState } from "react";
import { InHouseTooltip } from "@/components/InHouseTooltip/InHouseTooltip";
import { formatWeekRangeWithMonth } from "@/utils/dateFormatting";
import type { TimeOffRequest } from "@/utils/models";
import { TimeOffRequestDialog } from "./TimeOffRequestDialog";

type Props = {
	timeOffRequestsOfSpecificStaff: TimeOffRequest[];
	dateSpecificRequest: TimeOffRequest;
	refetchRequests?: (() => Promise<void>) | ((options?: RefetchOptions) => Promise<QueryObserverResult<TimeOffRequest[], Error>>);
	refetchDayOffRequestsLoading?: boolean;
};

export const ActiveTimeOffRequest: FC<Props> = ({ timeOffRequestsOfSpecificStaff, dateSpecificRequest, refetchRequests, refetchDayOffRequestsLoading }) => {
	const [dialogOpen, setDialogOpen] = useState(false);
	const handleIconClick = (_: MouseEvent) => {
		setDialogOpen(true);
	};

	const handleClose = () => {
		setDialogOpen(false);
	};

	return (
		<Box onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()}>
			<InHouseTooltip title={`Time off request between ${formatWeekRangeWithMonth(dateSpecificRequest.startDate, dateSpecificRequest.endDate, true)}`}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
					}}
				>
					<Box
						onClick={handleIconClick}
						sx={{
							p: 0.5,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							// we cant have button inside a button, so we use box with hover effect
							":hover": {
								cursor: "pointer",
								background: "#E0E0E0",
								borderRadius: "50%",
							},
						}}
					>
						<AssignmentIcon fontSize={"inherit"} sx={{ color: "#5F5CE8BF" }} />
					</Box>
					<Typography
						sx={{
							fontSize: {
								xs: "8px",
								xl: "12px",
								xxl: "14px",
							},
							fontWeight: 700,
							color: "#5F5CE8BF",
							whiteSpace: "nowrap",
						}}
					>
						TO
					</Typography>
				</Box>
			</InHouseTooltip>
			{/* Mounted only while open: every cell has one, and it reads the staff list. */}
			{dialogOpen && (
				<TimeOffRequestDialog
					dialogOpen={dialogOpen}
					handleClose={handleClose}
					timeOffRequestsOfSpecificStaff={timeOffRequestsOfSpecificStaff}
					refetchRequests={refetchRequests}
					refetchDayOffRequestsLoading={refetchDayOffRequestsLoading}
				/>
			)}
		</Box>
	);
};
